import { useMemo } from 'react';
import useAppNavigation from 'hooks/useAppNavigation';
import styled from 'styled-components';
import { LinkText } from './styles';
import usePendingEntityStatusModal from 'hooks/usePendingEntityStatusModal';
import { ActionMenu, useActionMenu } from 'components/ActionMenu';
import type { ActionMenuSection } from 'components/ActionMenu';

type Props = {
  entityId: number;
  targetServiceId: number;
  className?: string;
  onSingleEntityModalOpen: () => void;
  openPendingEntityStatusModal: ReturnType<
    typeof usePendingEntityStatusModal
  >['openPendingEntityStatusModal'];
};

const EntityIdOptionSelector = ({
  entityId,
  targetServiceId,
  className = '',
  onSingleEntityModalOpen,
  openPendingEntityStatusModal,
}: Props) => {
  const { navigateToEntityErrorsTable } = useAppNavigation();
  const { anchorEl, anchorPosition, isOpen, openMenu, closeMenu } = useActionMenu();

  const sections: ActionMenuSection[] = useMemo(
    () => [
      {
        items: [
          {
            label: 'View entity errors',
            onClick: () => {
              closeMenu();
              navigateToEntityErrorsTable({
                openInNewTab: true,
                targetServiceId,
                entityId: +entityId,
              });
            },
          },
          {
            label: 'View entity data',
            onClick: () => {
              closeMenu();
              onSingleEntityModalOpen();
            },
          },
          {
            label: 'Check status',
            onClick: () => {
              closeMenu();
              openPendingEntityStatusModal({
                targetServiceId,
                entityId: +entityId,
              });
            },
          },
        ],
      },
    ],
    [
      closeMenu,
      entityId,
      targetServiceId,
      navigateToEntityErrorsTable,
      onSingleEntityModalOpen,
      openPendingEntityStatusModal,
    ],
  );

  return (
    <Container className={className}>
      <LinkText onClick={(e) => openMenu(e.currentTarget as HTMLElement)}>{entityId}</LinkText>
      <ActionMenu
        anchorEl={anchorEl}
        anchorPosition={anchorPosition}
        open={isOpen}
        onClose={closeMenu}
        sections={sections}
      />
    </Container>
  );
};

export default EntityIdOptionSelector;

const Container = styled.div`
  &.transparent {
    .menu-container {
      background-color: transparent;
    }
  }
`;
